// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__32kaM","ranges":"BmiRanges_ranges__qU39l"};